import { useEffect, useState } from 'react';

/** Arquivo principal da versão que está aberta nesta aba (ex.: /assets/index-abc123.js). */
function versaoAtual(): string | null {
  const s = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]');
  return s ? new URL(s.src).pathname : null;
}

/**
 * Avisa quando o sistema foi atualizado enquanto a aba estava aberta.
 * Sem isso, quem deixa o sistema aberto o dia todo continua na versão antiga.
 */
export function UpdateBanner() {
  const [nova, setNova] = useState(false);

  useEffect(() => {
    const atual = versaoAtual();
    if (!atual) return; // ambiente de desenvolvimento
    let parado = false;
    async function conferir() {
      if (parado || document.visibilityState !== 'visible') return;
      try {
        const html = await fetch('/', { cache: 'no-store' }).then((r) => r.text());
        const publicada = html.match(/\/assets\/index-[^"']+\.js/)?.[0];
        if (publicada && publicada !== atual) setNova(true);
      } catch {
        /* sem conexão: tenta de novo depois */
      }
    }
    const id = window.setInterval(() => void conferir(), 3 * 60_000);
    const aoVoltar = () => void conferir();
    document.addEventListener('visibilitychange', aoVoltar);
    return () => {
      parado = true;
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', aoVoltar);
    };
  }, []);

  if (!nova) return null;
  return (
    <div className="update-banner" role="status">
      <span>Há uma versão nova do sistema.</span>
      <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
        Atualizar agora
      </button>
    </div>
  );
}
